import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCorrectWordsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCorrectWordsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly correctWords: ReadonlyArray<string> } | null } | null };


export const GetCorrectWordsDocument = gql`
    query GetCorrectWords {
  currentUser {
    currentCompany {
      correctWords
    }
  }
}
    `;

/**
 * __useGetCorrectWordsQuery__
 *
 * To run a query within a React component, call `useGetCorrectWordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorrectWordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorrectWordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCorrectWordsQuery(baseOptions?: Apollo.QueryHookOptions<GetCorrectWordsQueryPage, GetCorrectWordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorrectWordsQueryPage, GetCorrectWordsQueryVariables>(GetCorrectWordsDocument, options);
      }
export function useGetCorrectWordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorrectWordsQueryPage, GetCorrectWordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorrectWordsQueryPage, GetCorrectWordsQueryVariables>(GetCorrectWordsDocument, options);
        }
export function useGetCorrectWordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorrectWordsQueryPage, GetCorrectWordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorrectWordsQueryPage, GetCorrectWordsQueryVariables>(GetCorrectWordsDocument, options);
        }
export type GetCorrectWordsQueryHookResult = ReturnType<typeof useGetCorrectWordsQuery>;
export type GetCorrectWordsLazyQueryHookResult = ReturnType<typeof useGetCorrectWordsLazyQuery>;
export type GetCorrectWordsSuspenseQueryHookResult = ReturnType<typeof useGetCorrectWordsSuspenseQuery>;
export type GetCorrectWordsQueryResult = Apollo.QueryResult<GetCorrectWordsQueryPage, GetCorrectWordsQueryVariables>;